// extracted by mini-css-extract-plugin
module.exports = {"loaderOverlay":"Loader_loaderOverlay__TgQjJ","ldsRoller":"Loader_ldsRoller__LvUUf","lds-roller":"Loader_lds-roller__WGotT"};